(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    class FaubourgAccordion extends HTMLElement {
    handleResize = () => {
      this.sync();
    };

    connectedCallback() {
      this.root = this.querySelector('.accordion');
      this.summary = this.querySelector('.accordion__summary');
      this.plain = this.root.tagName === 'DIV';

      window.addEventListener('resize', this.handleResize);

      this.sync();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    get forcedOpen() {
      return getComputedStyle(this.root).getPropertyValue('--accordion-force-open').trim() === '1';
    }

    sync() {
      const forced = this.forcedOpen;
      if (forced === this.plain) return;

      const preserveFocus = this.summary.contains(document.activeElement);

      if (forced) {
        this.summary = this.retag(this.summary, 'div');
        this.root = this.retag(this.root, 'div');

        if (preserveFocus) this.focusHeading();
      } else {
        this.root = this.retag(this.root, 'details');
        this.root.open = true;
        this.summary = this.retag(this.summary, 'summary');

        if (preserveFocus) this.summary.focus({ preventScroll: true });
      }

      this.plain = forced;
    }

    focusHeading() {
      const heading = this.summary.querySelector('.accordion__heading');
      if (!heading) return;

      const hadTabindex = heading.hasAttribute('tabindex');

      if (!hadTabindex) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });

      if (!hadTabindex) {
        heading.addEventListener('blur', () => heading.removeAttribute('tabindex'), { once: true });
      }
    }

    retag(element, tagName) {
      const replacement = document.createElement(tagName);

      for (const { name, value } of element.attributes) {
        if (name === 'open') continue;
        replacement.setAttribute(name, value);
      }

      replacement.append(...element.childNodes);
      element.replaceWith(replacement);

      return replacement;
    }
  }

  if (!customElements.get('faubourg-accordion')) {
    customElements.define('faubourg-accordion', FaubourgAccordion);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    class FaubourgFacets extends HTMLElement {
    requestId = 0;
    controller = null;

    connectedCallback() {
      this.debounce = null;
      this.shown = this.#address();
      this.#takeValidation();

      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      this.addEventListener('submit', this.onSubmit);
      this.addEventListener('click', this.onClick);
      this.addEventListener('focusout', this.onFocusOut);

      this.onPopState = this.onPopState.bind(this);
      window.addEventListener('popstate', this.onPopState);

      if (this.classList.contains('facets--toolbar')) {
        document.addEventListener('click', this.onOutside);
        this.addEventListener('keydown', this.onKeydown);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
      document.removeEventListener('click', this.onOutside);
      clearTimeout(this.debounce);
      this.holdingBound = false;
      this.abort();
    }

    // A toolbar dropdown is let go of the way any disclosure over a page is:
    // by pressing anywhere else, or Escape, which hands focus back to its row.
    onOutside = (event) => {
      // Enter in a field presses the form's own submit, which stands outside
      // every group: that is the group being used, not let go of.
      if (event.target.closest && event.target.closest('.facets__apply')) return;
      for (const group of this.querySelectorAll('.facets__group[open]')) {
        if (!group.contains(event.target)) group.open = false;
      }
    };

    onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      const group = event.target.closest('.facets__group[open]');
      if (!group) return;
      group.open = false;
      const summary = group.querySelector('summary');
      if (summary) summary.focus();
    };

    abort() {
      if (this.controller) this.controller.abort();
      this.controller = null;
    }

    // The browser refuses an invalid bound by pointing at it, and in a drawer
    // the field it points at may sit in a panel the shopper has left, where it
    // can show nothing: the press did nothing and said nothing. With a script
    // here the form says it itself, where it can be seen.
    #takeValidation() {
      const form = this.form;
      if (form) form.noValidate = true;
    }

    // Everything staged and not committed is let go of: a pending count, a
    // bound still being typed, a reply still on its way.
    cancelStaged() {
      clearTimeout(this.debounce);
      this.holdingBound = false;
      this.previewId = (this.previewId || 0) + 1;
      if (this.previewController) this.previewController.abort();
      this.previewController = null;

      const footer = this.querySelector('.facets__drawer-footer');
      if (footer) footer.removeAttribute('aria-busy');
      const status = this.querySelector('[data-facets-staged-status]');
      if (status) status.textContent = '';
      for (const field of this.querySelectorAll('input[type="number"][aria-invalid]')) this.#clearBound(field);
    }

    formatCount(count) {
      const format = this.dataset.countFormat || '([count])';
      return format.replace('[count]', String(count));
    }

    // The first bound the form cannot send, or nothing. A lower bound above
    // the upper one is refused too: it could only ever find nothing.
    #invalidBound() {
      for (const error of this.querySelectorAll('[data-facets-range-error]')) {
        const panel = error.closest('.facets__panel');
        const bounds = panel ? panel.querySelectorAll('input[type="number"]') : [];
        if (bounds.length !== 2) continue;
        const [min, max] = bounds;
        for (const field of bounds) {
          field.setCustomValidity('');
          if (field.validity.rangeUnderflow) field.setCustomValidity(error.dataset.negativeMessage || '');
        }
        if (min.validity.valid && max.validity.valid && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
          max.setCustomValidity(error.dataset.orderMessage || '');
        }
        for (const field of bounds) {
          if (!field.checkValidity()) return { field, error };
        }
      }
      return null;
    }

    #showBound({ field, error }) {
      const drawer = this.drawer;
      if (drawer && drawer.isModal && typeof drawer.reveal === 'function') drawer.reveal(field);
      const group = field.closest('details');
      if (group) group.open = true;

      error.textContent = field.validationMessage;
      error.hidden = false;
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', error.id);
      field.focus();
    }

    #clearBound(field) {
      field.setCustomValidity('');
      field.removeAttribute('aria-invalid');
      const described = field.getAttribute('aria-describedby');
      if (!described) return;
      field.removeAttribute('aria-describedby');
      const error = document.getElementById(described);
      if (error) {
        error.hidden = true;
        error.textContent = '';
      }
    }

    // The next pill takes the focus, or the one before it when the last was
    // removed; with none left, the count of what the page now shows.
    #focusAfterRemoval({ pill }) {
      const pills = Array.from(this.querySelectorAll('[data-facets-bar] .facets__pill'));
      let target = pill >= 0 ? pills[pill] || pills[pill - 1] : null;

      if (!target) {
        target = document.getElementById(this.dataset.countId) || document.getElementById(this.dataset.resultsId);
        if (target && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      }

      if (target) target.focus();
    }

    // A bound is staged as it is typed, once the typing pauses, so the drawer
    // counts and reads back what the shopper is writing. Unfolded in the page
    // a change applies to the results and the history, so there it waits for
    // the field to be left.
    onInput = (event) => {
      if (event.target.type !== 'number') return;
      if (event.target.hasAttribute('aria-invalid')) this.#clearBound(event.target);
      if (!this.isStaged) return;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.update(), 700);
    };

    get form() {
      return this.querySelector('form');
    }

    get drawer() {
      return this.querySelector('.facets__drawer');
    }

    get isStaged() {
      const drawer = this.drawer;
      return !!(drawer && drawer.isModal);
    }

    onChange = (event) => {
      if (event.target.type === 'number') {
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => this.settleBound(), 700);
        return;
      }
      this.update();
    };

    // Unfolded in the page a bound applies once the shopper is done with the
    // pair: results that arrive while the other bound is being typed replace
    // the form, and take what has been typed with them.
    settleBound() {
      const field = document.activeElement;
      if (!this.isStaged && field && field.closest && this.contains(field) && field.closest('.facets__range')) {
        this.holdingBound = true;
        return;
      }
      this.update();
    }

    onFocusOut = (event) => {
      if (!this.holdingBound) return;
      const next = event.relatedTarget;
      if (next && next.closest && next.closest('.facets__range')) return;
      this.holdingBound = false;
      clearTimeout(this.debounce);
      this.update();
    };

    update() {
      const url = this.urlFromForm();
      if (this.isStaged) {
        this.stage(url);
        return;
      }

      // Unfolded in the page a change applies at once, so a bound the form
      // refuses is said now rather than sent.
      const invalid = this.#invalidBound();
      if (invalid) {
        this.#showBound(invalid);
        return;
      }
      this.apply(url);
    }

    onSubmit = (event) => {
      event.preventDefault();
      clearTimeout(this.debounce);
      this.holdingBound = false;

      const invalid = this.#invalidBound();
      if (invalid) {
        this.#showBound(invalid);
        return;
      }

      const drawer = this.drawer;
      const committing = !!(drawer && drawer.isModal);
      if (committing) drawer.close({ reason: 'commit' });

      const applied = this.apply(this.urlFromForm());

      if (committing) applied.then(() => this.scrollToResults());
    };

    scrollToResults() {
      const landing = document.getElementById(this.dataset.countId) || document.getElementById(this.dataset.resultsId);
      if (!landing) return;

      const root = getComputedStyle(document.documentElement);
      const header = parseFloat(root.getPropertyValue('--header-height')) || 0;
      const breathing = parseFloat(root.getPropertyValue('--space-inset')) || 0;

      const top = landing.getBoundingClientRect().top + window.scrollY - header - breathing;
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: Math.max(top, 0), behavior: reduced ? 'auto' : 'smooth' });
    }

    onClick = (event) => {
      const clear = event.target.closest('[data-facets-clear]');
      if (clear && this.contains(clear) && this.isStaged) {
        event.preventDefault();
        this.reset();
        // With nothing left to clear the link stops being one, so the focus
        // moves on to what the shopper does next: see the results.
        const commit = this.querySelector('[data-facets-commit]');
        if (commit) commit.focus();
        return;
      }

      const link = event.target.closest('a[href]');
      if (!link || !this.contains(link)) return;
      // Open in a new tab, window or download is the browser's, not a filter.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();

      // A pill or the bar's clear all goes away with the filter it removed,
      // so the focus it held is handed to what stands in its place.
      const bar = link.closest('[data-facets-bar]');
      const pills = bar ? Array.from(bar.querySelectorAll('.facets__pill')) : [];
      const focus = bar ? { pill: pills.indexOf(link) } : null;

      this.apply(link.href, focus);
    };

    reset() {
      const form = this.form;
      if (!form) return;

      for (const field of form.elements) {
        if (field.type === 'checkbox' || field.type === 'radio') {
          field.checked = false;
        } else if (field.type === 'number') {
          field.value = '';
        }
      }

      const sort = form.querySelector('select[name="sort_by"]');
      if (sort && form.dataset.defaultSort) sort.value = form.dataset.defaultSort;

      const drawer = this.drawer;
      if (drawer) {
        if (typeof drawer.syncSortChoices === 'function') drawer.syncSortChoices();
        if (typeof drawer.resetPanels === 'function') drawer.resetPanels();
      }

      this.update();
    }

    // Where the results on screen belong: a same-document navigation (the skip
    // link, any in-page anchor) fires popstate without changing this, and must
    // not discard what the shopper has loaded.
    #address() {
      const here = new URL(window.location.href);
      return here.pathname + here.search;
    }

    onPopState() {
      if (this.controller === null && this.#address() === this.shown) return;
      this.render(window.location.href, false);
    }

    // A number field accepts 1e2, which Shopify would read as 1. The price is
    // sent as the plain decimal the field holds, whatever way it was typed.
    #plainNumber(value) {
      return Number(value).toLocaleString('en-US', { useGrouping: false, maximumFractionDigits: 20 });
    }

    urlFromForm() {
      const form = this.form;
      const parameters = new URLSearchParams();

      for (const field of form.elements) {
        if (!field.name) continue;
        if (field.dataset.facetsIgnore !== undefined) continue;
        if (field.disabled) continue;
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (!field.checked) continue;
        }
        if (field.value === '') continue;
        parameters.append(field.name, field.type === 'number' ? this.#plainNumber(field.value) : field.value);
      }

      const query = parameters.toString();
      return query ? `${form.action}?${query}` : form.action;
    }

    apply(url, focus) {
      return this.render(url, true, focus);
    }

    stage(url) {
      const drawer = this.drawer;
      if (drawer && typeof drawer.refreshRows === 'function') drawer.refreshRows();
      this.previewCount(url);
    }

    async previewCount(url) {
      const commit = this.querySelector('[data-facets-commit]');
      if (!commit) return;

      this.previewId = (this.previewId || 0) + 1;
      const previewId = this.previewId;

      if (this.previewController) this.previewController.abort();
      const controller = new AbortController();
      this.previewController = controller;

      const footer = this.querySelector('.facets__drawer-footer');
      if (footer) footer.setAttribute('aria-busy', 'true');

      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(target.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error(response.statusText);

        const text = await response.text();
        if (previewId !== this.previewId) return;

        const markup = window.Faubourg.parseSection(text);
        const nextCommit = markup.querySelector('[data-facets-commit]');
        if (nextCommit) commit.textContent = nextCommit.textContent;

        // The server says what the staged form would apply in the store's own
        // words -- a price in its money -- so the rows read back its reply.
        for (const nextRow of markup.querySelectorAll('[data-facets-row]')) {
          const row = this.querySelector(`[data-facets-row="${CSS.escape(nextRow.dataset.facetsRow)}"]`);
          const values = row && row.querySelector('.facets__row-values');
          const nextValues = nextRow.querySelector('.facets__row-values');
          if (values && nextValues) values.innerHTML = nextValues.innerHTML;
        }

        const status = this.querySelector('[data-facets-staged-status]');
        if (status && nextCommit) status.textContent = nextCommit.textContent;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      } finally {
        if (previewId === this.previewId && footer) footer.removeAttribute('aria-busy');
      }
    }

    // The footer stands outside the two regions above, yet it says what the
    // results are: the count its commit would show, and where Clear all goes.
    #swapFooter(nextFacets) {
      const commit = this.querySelector('[data-facets-commit]');
      const nextCommit = nextFacets.querySelector('[data-facets-commit]');
      if (commit && nextCommit) commit.textContent = nextCommit.textContent;

      const clear = this.querySelector('[data-facets-clear]');
      const nextClear = nextFacets.querySelector('[data-facets-clear]');
      if (!clear || !nextClear) return;
      for (const name of ['data-clear-url', 'aria-disabled', 'href']) {
        if (nextClear.hasAttribute(name)) clear.setAttribute(name, nextClear.getAttribute(name));
        else clear.removeAttribute(name);
      }
    }

    swapFacets(nextFacets) {
      const bar = this.querySelector('[data-facets-bar]');
      const nextBar = nextFacets.querySelector('[data-facets-bar]');
      const content = this.querySelector('[data-facets-content]');
      const nextContent = nextFacets.querySelector('[data-facets-content]');

      if (!bar || !nextBar || !content || !nextContent) {
        this.innerHTML = nextFacets.innerHTML;
        return;
      }

      bar.innerHTML = nextBar.innerHTML;
      content.innerHTML = nextContent.innerHTML;
      this.#takeValidation();
      this.#swapFooter(nextFacets);

      const drawer = this.querySelector('.facets__drawer');
      if (drawer && typeof drawer.rebuild === 'function') drawer.rebuild();
    }

    async render(url, push, focus) {
      const results = document.getElementById(this.dataset.resultsId);
      if (!results) return;

      // A render replaces the form a staged preview was counting for: its
      // reply, still on the way, must not write into the new one.
      this.cancelStaged();

      this.requestId += 1;
      const requestId = this.requestId;

      this.abort();
      const controller = new AbortController();
      this.controller = controller;

      // What is busy is what is being replaced: the results and the applied
      // filters above them. Never this element itself -- busy is drawn as a
      // fade, and a faded ancestor would trap the drawer's veil and panel
      // beneath the grid while the drawer is still closing over it.
      const busy = [results, this.querySelector('[data-facets-bar]')].filter(Boolean);
      for (const region of busy) region.setAttribute('aria-busy', 'true');

      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', this.dataset.sectionId);

      try {
        const response = await fetch(target.toString(), { signal: controller.signal });
        if (!response.ok) throw new Error(response.statusText);

        const text = await response.text();

        if (requestId !== this.requestId) return;

        const markup = window.Faubourg.parseSection(text);

        const nextResults = markup.getElementById(this.dataset.resultsId);
        const nextFacets = markup.querySelector('faubourg-facets');
        if (!nextResults || !nextFacets) throw new Error('section markup did not match');

        const open = Array.from(this.querySelectorAll('.facets__group[open]')).map((group) => group.dataset.facet);
        const focused = document.activeElement;
        const focusedId = this.contains(focused) ? focused.id : null;

        // The new entry is in place before the new results are: what they build
        // themselves from -- load more reads its own entry -- is theirs, not the
        // page they replace.
        if (push) {
          const clean = new URL(url, window.location.origin);
          clean.searchParams.delete('section_id');
          window.history.pushState({}, '', clean.toString());
        }

        results.innerHTML = nextResults.innerHTML;
        this.swapFacets(nextFacets);
        this.shown = this.#address();

        const countId = this.dataset.countId;
        if (countId) {
          const count = document.getElementById(countId);
          const nextCount = markup.getElementById(countId);
          if (count && nextCount) count.textContent = nextCount.textContent;
        }

        // The trigger stands outside this element, in the section's toolbar,
        // and keeps its node -- and so its focus and its revealed state --
        // while the number of filters it announces changes.
        const triggerId = this.dataset.triggerId;
        if (triggerId) {
          const trigger = document.getElementById(triggerId);
          const nextTrigger = markup.getElementById(triggerId);
          if (trigger && nextTrigger) trigger.innerHTML = nextTrigger.innerHTML;
        }

        for (const group of this.querySelectorAll('.facets__group')) {
          if (open.includes(group.dataset.facet)) group.open = true;
        }

        if (focus) this.#focusAfterRemoval(focus);

        if (focusedId) {
          const restored = this.querySelector(`#${CSS.escape(focusedId)}`);
          if (restored) restored.focus();
        }
      } catch (error) {
        if (error && error.name === 'AbortError') return;
        if (requestId !== this.requestId) return;

        window.location.href = url;
      } finally {
        if (requestId === this.requestId) {
          for (const region of busy) region.removeAttribute('aria-busy');
          this.controller = null;
        }
      }
    }
  }

  if (!customElements.get('faubourg-facets')) {
    customElements.define('faubourg-facets', FaubourgFacets);
  }

  (function () {
    const Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    class FaubourgFacetsDrawer extends Drawer {
      #inline = null;
      #form = null;
      #content = null;
      #track = null;
      #root = null;
      #panels = [];
      #chain = [];
      #rowByPanel = new Map();
      #titleByPanel = new Map();
      #originByPanel = new Map();
      #hoisted = [];
      #applied = null;

      connectedCallback() {
        const shown = this.#takeOverPopover();
        this.setAttribute('data-enhanced', '');

        const from = this.dataset.inlineFrom;
        if (from) {
          this.#inline = window.matchMedia(`(min-width: ${from}px)`);
          this.#inline.addEventListener('change', this.#onBreakpoint);
        }

        super.connectedCallback();
        this.#sync();

        // A shopper who opened the form before the script arrived keeps it
        // open, now as the drawer.
        if (shown && this.isModal) this.open({ reason: 'popover' });
      }

      // Until now the panel was a native popover, so the form opened with no
      // script behind it. The drawer answers the trigger and the cross from
      // here on; left in place, the popover would open a second time over it.
      // Returns whether the shopper had it open.
      #takeOverPopover() {
        const panel = this.querySelector('[data-drawer-panel]');
        if (!panel || !panel.hasAttribute('popover')) return false;

        const shown = panel.matches(':popover-open');
        if (shown) panel.hidePopover();
        panel.removeAttribute('popover');

        for (const control of document.querySelectorAll(`[popovertarget="${CSS.escape(panel.id)}"]`)) {
          control.removeAttribute('popovertarget');
          control.removeAttribute('popovertargetaction');
        }

        return shown;
      }

      disconnectedCallback() {
        if (this.#inline) {
          this.#inline.removeEventListener('change', this.#onBreakpoint);
          this.#inline = null;
        }
        super.disconnectedCallback();
      }

      get isModal() {
        return !this.#inline || !this.#inline.matches;
      }

      open(options) {
        if (!this.isModal) return false;

        const opened = super.open(options);
        if (!opened) return opened;

        this.resetPanels();
        this.refreshRows();
        this.#applied = this.#snapshot();

        return opened;
      }

      // What the drawer said when it opened is what is applied: the words its
      // rows and its commit carried. The form's own defaults hold the rest,
      // since every apply renders the form afresh.
      #snapshot() {
        const commit = this.querySelector('[data-facets-commit]');
        return {
          commit: commit ? commit.textContent : null,
          rows: Array.from(this.querySelectorAll('[data-facets-row]')).map((row) => {
            const values = row.querySelector('.facets__row-values');
            return { row, values: values ? values.innerHTML : null };
          }),
        };
      }

      // Closed by anything but its commit, the drawer lets go of what was
      // staged in it: the next sort must not carry a choice the shopper
      // dismissed. The reset happens while the drawer is out of sight, so it
      // replays nothing.
      #restore() {
        const facets = this.closest('faubourg-facets');
        if (facets && typeof facets.cancelStaged === 'function') facets.cancelStaged();

        const form = this.querySelector('form.facets__form');
        if (form) form.reset();
        this.syncSortChoices();

        const applied = this.#applied;
        if (applied) {
          const commit = this.querySelector('[data-facets-commit]');
          if (commit && applied.commit !== null) commit.textContent = applied.commit;
          for (const entry of applied.rows) {
            const values = entry.row.querySelector('.facets__row-values');
            if (values && entry.values !== null) values.innerHTML = entry.values;
          }
        }

        this.refreshRows();
      }

      close(options) {
        const settings = options || {};
        const closed = super.close(settings);
        if (closed && settings.reason !== 'commit') this.#restore();
        if (closed) this.resetPanels();
        if (!closed || settings.returnFocus === false) return closed;

        const focused = document.activeElement;
        const stranded = !focused || focused === document.body || this.contains(focused);
        if (!stranded) return closed;

        const trigger = document.querySelector(`[data-drawer-target="${this.id}"]`);
        if (trigger) trigger.focus();

        return closed;
      }

      rebuild() {
        this.#teardownPanels();
        if (this.isModal) this.#buildPanels();
      }

      #buildPanels() {
        if (this.#track) return;

        const form = this.querySelector('form.facets__form');
        const content = this.querySelector('[data-facets-content]');
        const track = this.querySelector('[data-facets-track]');
        const root = this.querySelector('[data-facets-panel-root]');
        if (!form || !content || !track || !root) return;

        this.#form = form;
        this.#content = content;
        this.#track = track;
        this.#root = root;
        this.#panels = [root];

        this.#adoptSortPanel();
        this.#hoistBooleans(root);

        const groups = Array.prototype.slice.call(form.querySelectorAll('.facets__groups .facets__group'));
        groups.forEach((group) => this.#adoptGroup(group));

        track.hidden = false;

        const sort = form.querySelector('[data-facets-sort]');
        if (sort) sort.hidden = true;
        const groupsBox = form.querySelector('[data-facets-groups]');
        if (groupsBox) groupsBox.hidden = true;

        form.classList.add('facets__form--paneled');
        content.classList.add('facets__drawer-content--paneled');
        const panel = this.querySelector('[data-drawer-panel]');
        if (panel) panel.classList.add('facets__drawer-panel--paneled');

        const back = this.querySelector('[data-drawer-back]');
        if (back && !back.dataset.facetsBound) {
          back.dataset.facetsBound = 'true';
          back.addEventListener('click', () => this.drillBack());
        }

        this.#chain = [root];
        this.#syncPanels();
      }

      #teardownPanels() {
        if (!this.#track) return;

        for (const panel of this.#panels) {
          if (panel === this.#root) continue;
          panel.removeAttribute('data-panel-state');
          panel.removeAttribute('inert');
          const origin = this.#originByPanel.get(panel);
          if (origin) origin.appendChild(panel);
        }

        for (const entry of this.#hoisted) entry.origin.appendChild(entry.node);

        for (const input of this.#track.querySelectorAll('input[data-facets-ignore]')) {
          input.disabled = true;
        }

        this.#track.hidden = true;

        const sort = this.#form && this.#form.querySelector('[data-facets-sort]');
        if (sort) sort.hidden = false;
        const groupsBox = this.#form && this.#form.querySelector('[data-facets-groups]');
        if (groupsBox) groupsBox.hidden = false;

        if (this.#form) {
          this.#form.classList.remove('facets__form--paneled', 'facets__form--instant');
        }
        if (this.#content) this.#content.classList.remove('facets__drawer-content--paneled');
        const panel = this.querySelector('[data-drawer-panel]');
        if (panel) panel.classList.remove('facets__drawer-panel--paneled');

        window.Faubourg.overlayTrail(this, []);

        this.#form = null;
        this.#content = null;
        this.#track = null;
        this.#root = null;
        this.#panels = [];
        this.#chain = [];
        this.#rowByPanel = new Map();
        this.#titleByPanel = new Map();
        this.#originByPanel = new Map();
        this.#hoisted = [];
      }

      #row(key) {
        return this.querySelector(`[data-facets-row="${CSS.escape(key)}"]`);
      }

      #adoptSortPanel() {
        const panel = this.querySelector('[data-facets-panel="sort"]');
        const select = this.querySelector('select[name="sort_by"]');
        const row = this.#row('sort');
        if (!panel || !select || !row) return;

        for (const input of panel.querySelectorAll('input[type="radio"]')) {
          input.disabled = false;
          if (input.dataset.facetsBound) continue;
          input.dataset.facetsBound = 'true';
          input.addEventListener('change', () => {
            select.value = input.value;
            this.refreshRows();
          });
        }

        this.#panels.push(panel);
        this.#registerPanel(panel, row, panel.dataset.drilledTitle || '');
      }

      #hoistBooleans(root) {
        const groups = Array.prototype.slice.call(
          this.querySelectorAll('.facets__groups .facets__group[data-facet-type="boolean"]')
        );

        for (const group of groups) {
          const options = group.querySelectorAll('.facets__option');
          if (options.length !== 1) continue;

          const option = options[0];
          this.#hoisted.push({ node: option, origin: option.parentElement });
          option.classList.add('facets__row-check');
          root.insertBefore(option, root.firstChild);
          group.dataset.facetHoisted = 'true';
        }
      }

      #adoptGroup(group) {
        if (group.dataset.facetHoisted === 'true') return;

        const panel = group.querySelector(':scope > .facets__panel');
        const row = this.#row(group.dataset.facet || '');
        if (!panel || !row) return;

        this.#originByPanel.set(panel, group);
        this.#track.appendChild(panel);
        this.#panels.push(panel);
        this.#registerPanel(panel, row, panel.dataset.drilledTitle || group.dataset.facetLabel || '');
      }

      #registerPanel(panel, row, title) {
        this.#rowByPanel.set(panel, row);
        this.#titleByPanel.set(panel, title || '');

        if (row.dataset.facetsBound) return;
        row.dataset.facetsBound = 'true';
        row.addEventListener('click', () => this.drillInto(panel));
      }

      drillInto(panel) {
        if (!this.#panels.includes(panel)) return;

        this.#chain.push(panel);
        this.#syncPanels();

        const row = this.#rowByPanel.get(panel);
        if (row) row.setAttribute('aria-expanded', 'true');

        window.Faubourg.overlayTrail(this, [this.#titleByPanel.get(panel) || ''])?.focus();
      }

      // Brings the panel holding a field into view, so what is said about the
      // field can be seen beside it.
      reveal(field) {
        const panel = this.#panels.find((candidate) => candidate !== this.#root && candidate.contains(field));
        if (!panel || this.#chain[this.#chain.length - 1] === panel) return;
        this.resetPanels();
        this.drillInto(panel);
      }

      drillBack() {
        if (this.#chain.length <= 1) return;

        const leaving = this.#chain.pop();
        this.#syncPanels();
        window.Faubourg.overlayTrail(this, []);

        const row = this.#rowByPanel.get(leaving);
        if (!row) return;
        row.setAttribute('aria-expanded', 'false');
        row.focus();
      }

      resetPanels() {
        if (!this.#root) return;
        if (this.#chain.length === 1 && this.#chain[0] === this.#root) return;

        for (const panel of this.#panels) {
          const row = this.#rowByPanel.get(panel);
          if (row) row.setAttribute('aria-expanded', 'false');
        }

        this.#chain = [this.#root];
        window.Faubourg.overlayTrail(this, []);

        this.#syncPanels({ instant: true });
      }

      #syncPanels(options) {
        const settings = options || {};
        const active = this.#chain[this.#chain.length - 1];

        const applyStates = () => {
          for (const panel of this.#panels) {
            if (panel === active) {
              panel.dataset.panelState = 'active';
              panel.removeAttribute('inert');
            } else {
              panel.dataset.panelState = this.#chain.includes(panel) ? 'prev' : 'next';
              panel.setAttribute('inert', '');
            }
          }
        };

        if (!settings.instant || !this.#form) {
          applyStates();
          return;
        }

        this.#form.classList.add('facets__form--instant');
        applyStates();
        this.#form.offsetHeight;
        this.#form.classList.remove('facets__form--instant');
      }

      refreshRows() {
        for (const panel of this.#panels) {
          const row = this.#rowByPanel.get(panel);
          if (!row) continue;

          const summary = this.#summarise(panel);
          const isSort = row.dataset.facetsRow === 'sort';

          row.classList.toggle('facets__row--active', isSort || summary.count > 0);
          row.disabled = summary.exhausted;

          const count = row.querySelector('.facets__row-count');
          const values = row.querySelector('.facets__row-values');
          if (count) count.textContent = isSort || summary.count === 0 ? '' : this.#formatCount(summary.count);
          if (values && summary.values !== null) values.textContent = summary.values;
        }

        this.#refreshClear();
      }

      #summarise(panel) {
        const labels = [];
        let count = 0;

        for (const box of panel.querySelectorAll('.facets__checkbox:checked')) {
          count += 1;
          const label = box.parentElement && box.parentElement.querySelector('.facets__option-label');
          if (label) labels.push(label.textContent.trim());
        }

        // A price is said in the store's money, which only the server knows how
        // to write: its row keeps the words it has until the staged reply
        // brings the new ones.
        const bounds = panel.querySelectorAll('input[type="number"]');
        let priced = false;
        if (bounds.length === 2) {
          priced = true;
          if (bounds[0].value !== '' || bounds[1].value !== '') count += 1;
        }

        const boxes = panel.querySelectorAll('.facets__checkbox');
        const exhausted = boxes.length > 0 && Array.prototype.every.call(boxes, (box) => box.disabled);

        const separator = this.closest('faubourg-facets').dataset.listSeparator;
        return { count, values: priced ? null : labels.join(separator), exhausted };
      }

      #formatCount(count) {
        const facets = this.closest('faubourg-facets');
        if (facets && typeof facets.formatCount === 'function') return facets.formatCount(count);
        return String(count);
      }

      #refreshClear() {
        const clear = this.querySelector('[data-facets-clear]');
        if (!clear) return;

        const active = this.#panels.some((panel) => {
          const row = this.#rowByPanel.get(panel);
          if (row && row.dataset.facetsRow === 'sort') return false;
          return this.#summarise(panel).count > 0;
        });

        const hoisted = this.#hoisted.some((entry) => {
          const box = entry.node.querySelector('.facets__checkbox');
          return box && box.checked;
        });

        const enabled = active || hoisted;
        clear.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        if (enabled && clear.dataset.clearUrl) clear.setAttribute('href', clear.dataset.clearUrl);
        else clear.removeAttribute('href');
      }

      syncSortChoices() {
        const select = this.querySelector('select[name="sort_by"]');
        const panel = this.querySelector('[data-facets-panel="sort"]');
        if (!select || !panel) return;

        for (const input of panel.querySelectorAll('input[type="radio"]')) {
          input.checked = input.value === select.value;
        }
      }

      #onBreakpoint = () => {
        this.#sync();
      };

      // Whether this is a drawer at all is decided here, once, and stated for
      // the stylesheet: [data-inline] unfolds the form in the page. The
      // trigger is the stylesheet's to withdraw, from the same breakpoint, so
      // it stands the same with or without this script.
      #sync() {
        const panel = this.querySelector('[data-drawer-panel]');
        const modal = this.isModal;

        this.toggleAttribute('data-inline', !modal);

        if (modal) {
          if (panel) {
            panel.setAttribute('role', 'dialog');
            panel.setAttribute('aria-modal', 'true');
          }
          this.#buildPanels();
          return;
        }

        this.close({ force: true, returnFocus: false, animate: false, reason: 'breakpoint' });
        this.removeAttribute('inert');
        this.removeAttribute('aria-hidden');

        if (panel) {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-modal');
        }

        this.#teardownPanels();
      }
    }

    if (!customElements.get('faubourg-facets-drawer')) {
      customElements.define('faubourg-facets-drawer', FaubourgFacetsDrawer);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay-header"] && !Shopify.designMode) return;
  try {
    (function () {
    var scope = (window.Faubourg = window.Faubourg || {});
    if (scope.overlayTrail) return;

    // Titles a drilling drawer's header with a trail -- its own title, then
    // each panel drilled into, outermost first -- and shows the way back while
    // there is somewhere to go back to. Returns that control, for the drawer
    // to hand the focus to. The root title is the one the page was served.
    scope.overlayTrail = function (drawer, steps) {
      var title = drawer.querySelector('[data-drawer-title]');
      var back = drawer.querySelector('[data-drawer-back]');
      var crumb = drawer.querySelector('[data-drawer-crumb]');

      if (title) {
        if (title.dataset.rootTitle === undefined) title.dataset.rootTitle = title.textContent.trim();

        var parts = [document.createTextNode(title.dataset.rootTitle)];
        for (var index = 0; index < steps.length; index += 1) {
          if (crumb) parts.push(crumb.content.cloneNode(true));
          parts.push(document.createTextNode(steps[index]));
        }
        title.replaceChildren.apply(title, parts);
      }

      if (back) back.hidden = steps.length === 0;
      return back;
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.faubourgProductCardSwatches) return;
    window.faubourgProductCardSwatches = true;

    var CARD = '.product-card';
    var TRIGGER = '.product-card__variants-trigger[data-swatch-src]';

    function imageOf(card) {
      return card.querySelector('.product-card__image--primary');
    }

    function preview(trigger) {
      var card = trigger.closest(CARD);
      if (!card) return;

      var image = imageOf(card);
      if (!image) return;

      if (typeof image.dataset.cardSrc === 'undefined') {
        image.dataset.cardSrc = image.getAttribute('src') || '';
        image.dataset.cardSrcset = image.getAttribute('srcset') || '';
      }

      image.setAttribute('src', trigger.dataset.swatchSrc);
      image.setAttribute('srcset', trigger.dataset.swatchSrcset || '');
      card.setAttribute('data-previewing', '');
    }

    function restore(card) {
      card.removeAttribute('data-previewing');

      var image = imageOf(card);
      if (!image) return;
      if (typeof image.dataset.cardSrc === 'undefined') return;

      image.setAttribute('src', image.dataset.cardSrc);
      image.setAttribute('srcset', image.dataset.cardSrcset);
    }

    function onEnter(event) {
      var trigger = event.target.closest && event.target.closest(TRIGGER);
      if (trigger) preview(trigger);
    }

    function onLeave(event) {
      var card = event.target.closest && event.target.closest(CARD);
      if (!card) return;

      var to = event.relatedTarget;
      if (to && card.contains(to)) return;

      restore(card);
    }

    document.addEventListener('pointerover', onEnter);
    document.addEventListener('pointerout', onLeave);
    document.addEventListener('focusin', onEnter);
    document.addEventListener('focusout', onLeave);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    const Drawer = window.Faubourg && window.Faubourg.Drawer;
    if (!Drawer) return;

    const LINK = 'a[data-quick-add]';

    class QuickAddDrawer extends Drawer {
      #controller = null;
      #listener = null;

      connectedCallback() {
        super.connectedCallback();
        this.#listener = new AbortController();
        document.addEventListener('click', this.#onClick, { signal: this.#listener.signal });
      }

      disconnectedCallback() {
        if (this.#listener) this.#listener.abort();
        this.#listener = null;
        if (this.#controller) this.#controller.abort();
        super.disconnectedCallback();
      }

      // A new tab, a new window, a download: the shopper asked for the page.
      #onClick = (event) => {
        if (event.defaultPrevented || event.button !== 0) return;
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const link = event.target instanceof Element ? event.target.closest(LINK) : null;
        if (!link) return;

        event.preventDefault();
        this.show(link);
      };

      get content() {
        return this.querySelector('[data-quick-add-content]');
      }

      #setTitle(text) {
        const title = this.querySelector('[data-drawer-title]');
        if (title && text) title.textContent = text;
      }

      async show(link) {
        const content = this.content;
        // With nowhere to show anything, the page is the only answer left.
        if (!content) {
          window.location.assign(link.href);
          return;
        }

        if (this.#controller) this.#controller.abort();
        const controller = new AbortController();
        this.#controller = controller;

        // The drawer opens at once, titled with the product, and fills when
        // its content arrives; the last product it showed is not left in it.
        content.replaceChildren();
        content.setAttribute('aria-busy', 'true');
        this.#setTitle(link.dataset.quickAddTitle);
        if (!this.isOpen) this.open({ trigger: link, reason: 'quick-add' });

        try {
          const target = this.#address(link);
          target.searchParams.set('section_id', 'quick-add');

          const [response] = await Promise.all([
            fetch(target.toString(), { signal: controller.signal }),
            this.#loadScripts(),
          ]);
          if (!response.ok) throw new Error(response.status);

          // Read through the layout's reader, which adopts the rules the
          // section came with and drops its scripting-off fallbacks: the nodes
          // are imported, not re-parsed. See layout/theme.liquid.
          const markup = window.Faubourg.parseSection(await response.text());
          const section = markup.querySelector('.quick-add');
          if (!section) throw new Error('quick add markup missing');
          if (controller !== this.#controller) return;

          content.replaceChildren(document.importNode(section, true));
          content.removeAttribute('aria-busy');

          // Focus moves from the panel to the first thing the shopper can do.
          if (this.isOpen && this.contains(document.activeElement)) Drawer.focusFirst(content);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          if (controller !== this.#controller) return;
          this.#fail(content, link);
        }
      }

      // The product's own address: a card inside a recommendation or a search
      // result links with the tracking of where it was shown, which neither the
      // section request nor the page it leads to has any use for. What the
      // card chose stays: a filtered card or a changed swatch links with its
      // variant, and the drawer opens on that one.
      #address(link) {
        const address = new URL(link.href, window.location.origin);
        const chosen = ['variant', 'option_values'].map((name) => [name, address.searchParams.get(name)]);
        address.search = '';
        chosen.forEach(([name, value]) => value && address.searchParams.set(name, value));
        window.Faubourg.carryPageParams(address);
        return address;
      }

      // The drawer is open and the shopper is in it: the failure is told here,
      // announced, with the page one choice away.
      #fail(content, link) {
        const notice = this.querySelector('template[data-quick-add-failed]');
        if (!notice) return;

        const message = notice.content.cloneNode(true);
        message.querySelector('[data-quick-add-failed-link]').href = this.#address(link).toString();
        content.replaceChildren(message);
        content.removeAttribute('aria-busy');
      }

      // The page may never have rendered a picker, a gallery or a gift card's
      // recipient fields, so it may never have received their scripts. Each is
      // fetched once, before the element it upgrades is shown.
      #loadScripts() {
        const sources = this.querySelectorAll('[data-quick-add-script]');
        return Promise.all(
          Array.from(sources, (source) =>
            customElements.get(source.dataset.element) ? null : import(source.dataset.quickAddScript)
          )
        );
      }
    }

    if (!customElements.get('faubourg-quick-add-drawer')) {
      customElements.define('faubourg-quick-add-drawer', QuickAddDrawer);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-field"] && !Shopify.designMode) return;
  try {
    /*
   * The clear control is an enhancement: it stays hidden until a script can
   * empty the field, and without one the line is a plain search box. The
   * search sheet's own engine already owns its clear, so this steps aside
   * inside it.
   */
  (function () {
    function owned(field) {
      return field && !field.closest('faubourg-predictive-search');
    }

    function sync(field) {
      var clear = field.querySelector('[data-search-clear]');
      var input = field.querySelector('.search-field__input');
      if (clear && input) clear.hidden = input.value === '';
    }

    function syncAll() {
      document.querySelectorAll('.search-field').forEach(function (field) {
        if (owned(field)) sync(field);
      });
    }

    document.addEventListener('input', function (event) {
      var field = event.target.closest && event.target.closest('.search-field');
      if (owned(field)) sync(field);
    });

    document.addEventListener('click', function (event) {
      var clear = event.target.closest && event.target.closest('[data-search-clear]');
      var field = clear && clear.closest('.search-field');
      if (!owned(field)) return;
      var input = field.querySelector('.search-field__input');
      input.value = '';
      sync(field);
      input.focus();
    });

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
    else syncAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
